export const readFormData = async <Fields>(request: Request) =>
  Object.fromEntries(await request.formData()) as Fields;
